import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import TranslateIcon from '@mui/icons-material/Translate';
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";

const LanguageSelector = ({ hoverColor, navDropdown, noLiPadding, buttonProps }) => {
  const { i18n } = useTranslation();

  const getLanguageDisplay = (langCode) => {
    switch (langCode) {
      case "de":
        return "🇩🇪 Deutsch";      // German
      case "en":
        return "🇬🇧 English";      // English
      case "tr":
        return "🇹🇷 Türkçe";       // Turkish
      case "ru":
        return "🇷🇺 Русский";      // Russian
      case "fr":
        return "🇫🇷 Français";     // French
      case "ar":
        return "🇸🇦 العربية";      // Arabic
      case "it":
        return "🇮🇹 Italiano";     // Italian
      case "uk":
        return "🇺🇦 Українська";   // Ukrainian
      default:
        return langCode;
    }
  };
  
  const handleLanguageChange = (item) => {
    const selectedLang = item?.key;
    if (selectedLang && selectedLang !== i18n.language) {
      i18n.changeLanguage(selectedLang);
      localStorage.setItem("appLanguage", selectedLang);
      window.location.reload();
    }
  };

  const itemStyle = {
    fontSize: '1rem',
    textAlign: 'center',
    width: '100%',
    padding: '5px 0'
  };

  const languageOptions = [
    <div key="de" style={itemStyle}>{getLanguageDisplay("de")}</div>,
    <div key="en" style={itemStyle}>{getLanguageDisplay("en")}</div>,
    <div key="tr" style={itemStyle}>{getLanguageDisplay("tr")}</div>,
    <div key="ru" style={itemStyle}>{getLanguageDisplay("ru")}</div>,
    <div key="fr" style={itemStyle}>{getLanguageDisplay("fr")}</div>,
    <div key="ar" style={itemStyle}>{getLanguageDisplay("ar")}</div>,
    <div key="it" style={itemStyle}>{getLanguageDisplay("it")}</div>,
    <div key="uk" style={itemStyle}>{getLanguageDisplay("uk")}</div>,
  ];
  

  return (
    <CustomDropdown
      hoverColor={hoverColor}
      navDropdown={navDropdown}
      noLiPadding={noLiPadding}
      buttonText={getLanguageDisplay(i18n.language)}
      buttonIcon={TranslateIcon}
      dropdownList={languageOptions}
      onClick={handleLanguageChange}
      buttonProps={{
        ...buttonProps,
        color: buttonProps?.color || "transparent",
      }}
      caret
    />
  );
};

LanguageSelector.propTypes = {
  hoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
  ]),
  navDropdown: PropTypes.bool,
  noLiPadding: PropTypes.bool,
  buttonProps: PropTypes.object,
};

LanguageSelector.defaultProps = {
  hoverColor: "primary",
  navDropdown: true,
  noLiPadding: true,
  buttonProps: {},
};

export default LanguageSelector;